import { render, staticRenderFns } from "./Responsepopup.vue?vue&type=template&id=4da566f4&scoped=true&"
import script from "./Responsepopup.vue?vue&type=script&lang=js&"
export * from "./Responsepopup.vue?vue&type=script&lang=js&"
import style0 from "./Responsepopup.vue?vue&type=style&index=0&id=4da566f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da566f4",
  null
  
)

export default component.exports